/**
 * Accordion functionality
 */

$('.js-accordion').on('click', '.accordion__head', function(event) {
	event.preventDefault();
	$(this)
		.parent()
		.toggleClass('is-active')
		.find('.accordion__body')
		.stop()
		.slideToggle()
		.end()
		.siblings()
			.removeClass('is-active')
			.find('.accordion__body')
			.slideUp();
});
